<template>
<div class="arrived-index ">
    <div class="arrived-content w">
        <div class="tab-header">
            <div 
                class="tab-item" 
                :class="{ active: arrived_state === '1' }" 
                @click="switchTab('1')"
            >
                今日到货
            </div>

            <!-- <div 
                class="tab-item" 
                :class="{ active: arrived_state === '2' }" 
                @click="switchTab('2')"
            >
                即将到货
            </div>
            <div 
                class="tab-item" 
                :class="{ active: arrived_state === '3' }" 
                @click="switchTab('3')"
            >
                延期到货
            </div> -->
            <!-- 1 -->
        </div>
        <!-- 顶部信息栏 -->
        <div class="top-info">
            <div class="total-count">{{ arrived_state === '1' ? '今日到货' : arrived_state === '2' ? '即将到货' : '延期到货' }}：
                <span class="value">{{ allTotal }}</span>
            </div>
            <div class="search-box">
                <el-input 
                    v-model="searchText" 
                    placeholder="搜索配件" 
                    clearable
                    size="small"
                    @keyup.enter="handleSearch"
                >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    <el-button 
                        slot="append" 
                        type="primary" 
                        size="small" 
                        @click="handleSearch"
                    >搜索</el-button>
                </el-input>
            </div>
        </div>
        
        <!-- 品牌列表 -->
        <div class="brand-logo-list" v-if="brandList && brandList.length > 0">
            <div class="brand-list-wrapper" :style="{'height': brandExpandH}">
                <el-row :gutter="15">
                    <el-col v-for="(brand, i) in brandList" :key="i" :span="3">
                        <div 
                            class="img-box" 
                            :class="{ 'selected': selectedBrand === brand.oenaturebrand }"
                            @click="getListByBrand(brand.oenaturebrand)"
                        >
                           
                            <el-image :src="`https://huanuowei.cn/images/hnw/web/brand/${brand.oenaturebrand}.png`">
                                <div slot="error" class="image-slot">
                                    {{ brand.oenaturebrand }}
                                </div>
                            </el-image>
                            <div class="brand-num">{{ brand.num }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="toggle" v-if="brandList.length > 4" @click="toggleBrandExpand">
                <div class="toggle-button" >
                    <i :class="brandExpandH=='auto' ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    <div class="toggle-text">{{ brandExpandH=='auto' ? '收起' : '展开' }}</div>
                </div>
            </div>
        </div>
        
        <!-- 名称列表 -->
        <div class="goods-names-list" v-if="goodsNamesList && goodsNamesList.length > 0">
            <div class="names-list-wrapper" :style="{'height': goodsNameExpandH}">
                <span 
                    v-for="(name, index) in goodsNamesList" 
                    :key="index"
                    class="name-item" 
                    :class="{ 'active': selectedGoodsName === name }"
                    @click="getListByGoodsName(name)"
                >
                    {{ name }}
                </span>
            </div>
            <div class="toggle" v-if="goodsNamesList.length > 4" @click="toggleGoodsNameExpand">
               
                <div class="toggle-button" >
                    <i :class="goodsNameExpandH=='auto' ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    <div class="toggle-text">{{ goodsNameExpandH=='auto' ? '收起' : '展开' }}</div>
                </div>
            </div>
        </div>
        
        <!-- 配件列表 -->
        <div class="parts-list">
            <div class="product"  ref="tableHead">
                <ul class="teble-head">
                    <li class="oecode">OE号
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'oecode1' }"
                                @click="sortChange('oecode', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'oecode2' }"
                                @click="sortChange('oecode', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="goods_name">商品名称
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'goods_name1' }"
                                @click="sortChange('goods_name', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'goods_name2' }"
                                @click="sortChange('goods_name', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="sccode">生产编码
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'sccode1' }"
                                @click="sortChange('sccode', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'sccode2' }"
                                @click="sortChange('sccode', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="oenaturebrand">配件品牌
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'oenaturebrand1' }"
                                @click="sortChange('oenaturebrand', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'oenaturebrand2' }"
                                @click="sortChange('oenaturebrand', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="goods_storage">库存
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'goods_storage1' }"
                                @click="sortChange('goods_storage', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'goods_storage2' }"
                                @click="sortChange('goods_storage', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="goods_price">订货价
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'goods_price1' }"
                                @click="sortChange('goods_price', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'goods_price2' }"
                                @click="sortChange('goods_price', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="specification">规格</li>
                    <li class="numAd">订货数量</li>
                    <li class="handle-box">操作</li>
                </ul>
            </div>
            <div class="cargo">
                <ul>
                    <li 
                        class="case-list" 
                        v-for="(goods, index) in arrivedList" 
                        :key="index"
                        
                    >
                        <div class="details">
                            <div class="isOe" @click.stop="showGoodsInfo(goods)">
                                <div class="isOe-left">
                                    <div class="isOe-top">
                                        <div class="name">{{ goods.oenaturebrand }}</div>
                                        <div class="number">
                                            {{ goods.oecode }}
                                        </div>
                                        <HnwCopy :data="goods.oecode"></HnwCopy>
                                        <div class="tag-icon" v-if="goods.isExchange">
                                            互
                                        </div>
                                    </div>
                                    <div class="vehicleModel" v-if="goods.vehicletype">车型：{{ goods.vehicletype }}</div>
                                </div>
                                <div class="watermark-text"> {{ $store.state.nickname||$store.state.member_name||"" }}  {{ $store.state.member_id }}</div>
                            </div>
                            <div @click.stop="showGoodsInfo(goods)" class="productName" :title="goods.goods_name">
                                {{ goods.goods_name }}
                                <div class="product-top">
                                    <img class="cx-icon" src="../../assets/common/cuxiao.png" v-if="goods.isMcx" alt="" srcset="">
                                    <div v-if="goods.goods_commend==71" class="dis-good-tips-small">
                                        {{goods.roiZ}} 折
                                    </div>
                                    <div v-if="goods.goodsPosImg" class="share-btn" @click.stop="shareGoods(goods)">
                                        <img src="../../assets/common/分享.jpg" alt="" srcset="">
                                    </div>
                                </div>

                                <div class="del-time red" v-if="goods.delivery_time">
                                    预计到货: {{ goods.delivery_time}}
                                </div>
                            </div>
                            
                            <div class="encoding" :title="goods.sccode">
                                {{ goods.sccode }}
                                <HnwCopy :data="goods.sccode"></HnwCopy>
                            </div>
    
                            <div class="brand" :title="goods.oenaturebrand" :class="{'selfBrand': goods.hnw_self}">
                                {{ goods.oenaturebrand }}
                                <span class="hnw-self-brand" v-if="goods.hnw_self">
                                    自主品牌
                                </span>
                            </div>
                            <div class="inventory" :class="{'disabled-color':goods.goods_storage==0}">
                                <template v-if="$store.state.member_id.includes('1780')">
                                    <div class="goods-location">
                                        <template v-if="$store.state.is_sh == 1">
                                            <div style="font-size:14px;">上海:
                                                <span v-if="$store.state.look_inv==1">{{goods.sh_storage}}</span>
                                                <span v-else>{{goods.sh_storage>0?"有货":"无货"}}</span>
                                            </div>
                                            <div style="font-size:12px;">丹阳:
                                                <span v-if="$store.state.look_inv==1">{{goods.goods_stcids}}</span>
                                                <span v-else>{{goods.goods_stcids>0?"有货":"无货"}}</span>
                                            </div>
                                        </template>
                                        
                                        <template v-else>
                                            <div style="font-size:14px;">丹阳:
                                                <span v-if="$store.state.look_inv==1">{{goods.goods_stcids}}</span>
                                                <span v-else>{{goods.goods_stcids>0?"有货":"无货"}}</span>
                                            </div>
                                            <div style="font-size:12px;">上海:
                                                <span v-if="$store.state.look_inv==1">{{goods.sh_storage}}</span>
                                                <span v-else>{{goods.sh_storage>0?"有货":"无货"}}</span>
                                            </div>
                                        </template>
                                    </div>
                                    <div v-if="$store.state.member_id.includes('1780')" class="loca-btn" @click.stop="openAll(goods)"><span>货位详情</span></div>
                                </template>
                                <div v-else>
                                    <span v-if="$store.state.look_inv==1">{{goods.goods_storage}}</span>
                                    <span v-else :class="{'disabled-color':goods.goods_storage==0}">{{goods.goods_storage>0?"有货":"无货"}}</span>
                                </div>
                                <div class="arrival-btn-box" v-if="arrived_state !== '1'">
                                    <el-button 
                                        v-if="arrived_state === '2' || arrived_state === '3'" 
                                        type="primary" 
                                        size="mini" 
                                        @click.stop="addArrivalRemind(goods)"
                                    >添加提醒</el-button>
                                    <el-button 
                                        v-if="arrived_state === '3'" 
                                        type="warning" 
                                        size="mini" 
                                        @click.stop="addUrge(goods)"
                                    >催交期</el-button>
                                </div>
                            </div>
                            
    
                            <div class="TheOrderPrice">
                                <div class="watermark-text"> {{ $store.state.nickname||$store.state.member_name||"" }}  {{ $store.state.member_id }} </div>
                                ¥ {{ goods.goods_price }}
                                <span v-if="goods.brand_ratio_price">({{goods.brand_ratio_price}})</span>
                                <div v-if="goods.goods_commend==71" class="dis-good-tips-small">
                                    {{goods.roiZ}} 折
                                </div>
                            </div>
    
                            <div class="specification">
                                {{ goods.spec }}
                            </div>
    
                            <div class="numAd" @click.stop>
                                <el-input-number 
                                    v-if="$store.state.zero_buy==1" 
                                    v-model="goods.goods_num" 
                                    :min="1" 
                                    size="mini"
                                ></el-input-number>
                                <el-input-number 
                                    v-else 
                                    v-model="goods.goods_num" 
                                    @change="impueNumChange(goods)" 
                                    :min="1" 
                                    size="mini"
                                ></el-input-number>
                            </div>
    
                            <div class="handle-box">
                                <div 
                                    class="add-btn" 
                                    :class="{'ycg-btn':goods.goods_storage==0}" 
                                    @click.stop="joinCart(goods)"
                                >
                                    {{goods.goods_storage>0?'加入购物车':'加入预购单'}}
                                </div>
                                <div class="addition">
                                    <span v-if="goods.cartNum">
                                        已添加 {{goods.cartNum}} 件
                                    </span>
                                </div>
                                <el-popover
                                    placement="left"
                                    width="260"
                                    popper-class="pop-replace-list"
                                    v-model="goods.replacePopVis"
                                    trigger="click"
                                >
                                    <div class="pop-close" @click.stop="goods.replacePopVis=false">
                                        <i class="el-icon-close"></i>
                                    </div>
                                    <el-table :border="false" class="replace-table" :data="buyStoreList" height="300">
                                        <el-table-column width="60" type="index" label="序号"></el-table-column>
                                        <el-table-column width="120" property="oecode" label="互换件号">
                                            <template slot-scope="scope1">
                                                <span>{{scope1.row.oecode}}</span>
                                                <HnwCopy :data="scope1.row.oecode"></HnwCopy>
                                            </template>
                                        </el-table-column>
                                        <el-table-column width="80" property="address" label="操作">
                                            <template slot-scope="scope1">
                                                <span class="show-btn" style="cursor: pointer" v-if="scope1.row.goods_id" @click="toSearch(scope1.row)">
                                                    在售
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div 
                                        class="replace-btn" 
                                        @click.stop="showChangeParts(goods)" 
                                        type="text" 
                                        slot="reference" 
                                        v-if="goods.exchange && goods.exchange.length>0"
                                    >
                                        查看互换件
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                        
                        <!-- 历史购买记录 -->
                        <div class="goods-ex-msg" v-if="goods.orderInfo">
                            <div class="buyHis" @click.stop="readHisList(goods.goods_id)">
                                您最近一次购买：
                                <span>
                                    {{$hnwTools.formatDateTime(goods.orderInfo.add_time,'ymd')}}
                                </span>
                                <span>
                                    {{goods.orderInfo.goods_num?goods.orderInfo.goods_num:0}} 个
                                </span>
                                <span class="readMore">
                                    更多
                                </span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            
            <div class="pages">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    background
                    :page-sizes="[10, 20, 30, 50,99999]"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        
        <!-- 货位详情弹窗 -->
        <el-dialog
            title="货位详情"
            :visible.sync="openAllotion"
            width="50%"
        >
            <div class="alltion">
                <div>OE号</div>
                <div>仓库</div>
                <div>货位</div>
                <div>库存</div>
            </div>
    
            <template v-if="goodsAllotion.dy.list.length>0">
                <div class="alltion">
                    <div style="width: 100%;">丹阳</div>
                </div>
                <div class="alltion" v-for="(item) in goodsAllotion.dy.list" :key="item.shelfId">
                    <div class="item">{{item.code}}</div>
                    <div class="item">{{item.warehouseName}}</div>
                    <div class="item">{{item.shelfName}}</div>
                    <div class="item">{{item.shelfStockNum}}</div>
                </div>
            </template>
            <template v-if="goodsAllotion.sh.list.length>0">
                <div class="alltion">
                    <div style="width: 100%;">上海</div>
                </div>
                <div class="alltion" v-for="(item) in goodsAllotion.sh.list" :key="item.shelfId">
                    <div class="item">{{item.code}}</div>
                    <div class="item">{{item.warehouseName}}</div>
                    <div class="item">{{item.shelfName}}</div>
                    <div class="item">{{item.shelfStockNum}}</div>
                </div>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="openAllotion = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="openAllotion = false">确 定</el-button>
            </span>
        </el-dialog>
        
        <!-- 历史购买记录弹窗 -->
        <el-dialog title="历史购买记录" :visible.sync="hisVis" center width="800px">
            <div class="his-list">
                <div class="list-head">
                    <div>购买时间</div>
                    <div>发货时间</div>
                    <div>购买人</div>
                    <div class="col-100">价格</div>
                    <div class="col-100">购买个数</div>
                    <div class="col-100">订单状态</div>
                </div>
                <div class="list-body">
                    <div class="row" v-for="(his,index) in gooodsHisList" :key="index">
                        <div>{{$hnwTools.formatDateTime(his.add_time,'ymd')}}</div>
                        <div>{{$hnwTools.formatDateTime(his.delay_time,'ymd')||"无"}}</div>
                        <div>{{his.member_name}}</div>
                        <div class="col-100">{{his.goods_price}}</div>
                        <div class="col-100">{{his.goods_num}}</div>
                        <div class="col-100">{{$hnwTools.getOrderStateText(his.order_state)}}</div>
                    </div>
                </div>
            </div>
        </el-dialog>

    </div>

</div>
</template>

<script>
export default {
    data(){
        return{
            brandList: [
                
            ],
            goodsNamesList: [],
            selectedGoodsName: '',
            brandExpandH: "138px",
            goodsNameExpandH: "auto",
            arrived_state:"1",
            selectedBrand: '',
            arrivedList: [],
            total: 0,
            allTotal: 0,
            currentPage: 1,
            pageSize: 10,
            searchText: '',
            selectedBrand: '',
            // 排序相关
            acSort: '',
            // 互换件相关
            buyStoreList: [],
            // 货位详情相关
            openAllotion: false, // 货位详情弹窗显示控制
            goodsAllotion: {
                dy: {
                    title: "丹阳",
                    list: []
                },
                sh: {
                    title: "上海",
                    list: []
                }
            },
            // 历史购买记录相关
            gooodsHisList: [],
            hisVis: false
        }
    },
    methods:{
        // 排序变化
        async sortChange(type, way) {
            let sort_way = way;
            let sort_type = type;
            this.acSort = sort_type + sort_way;
            this.currentPage = 1;
            this.getArrivedList({});
        },
        // 切换tab
        switchTab(state) {
            this.arrived_state = state;
            this.getArrivedList({ 
                type: 'screen'
            });
        },
        async getArrivedList(params) {
            let searParams = {
                store_curpage: this.currentPage,
                store_page: this.pageSize,
                arrived_state: this.arrived_state,
                goods_name: this.selectedGoodsName,
                oenaturebrand: this.selectedBrand,
                ...params
            };
            
            // 如果有排序，添加排序参数
            if (this.acSort) {
                if (this.acSort.includes('goods_storage')) {
                    searParams.sort_type = 'goods_storage';
                    searParams.sort_way = this.acSort === 'goods_storage1' ? '2' : '1';
                } else if (this.acSort.includes('goods_price')) {
                    searParams.sort_type = 'goods_price';
                    searParams.sort_way = this.acSort === 'goods_price1' ? '2' : '1';
                } else if (this.acSort.includes('oecode')) {
                    searParams.sort_type = 'oecode';
                    searParams.sort_way = this.acSort === 'oecode1' ? '2' : '1';
                } else if (this.acSort.includes('goods_name')) {
                    searParams.sort_type = 'goods_name';
                    searParams.sort_way = this.acSort === 'goods_name1' ? '2' : '1';
                } else if (this.acSort.includes('sccode')) {
                    searParams.sort_type = 'sccode';
                    searParams.sort_way = this.acSort === 'sccode1' ? '2' : '1';
                } else if (this.acSort.includes('oenaturebrand')) {
                    searParams.sort_type = 'oenaturebrand';
                    searParams.sort_way = this.acSort === 'oenaturebrand1' ? '2' : '1';
                }
            }
            
            let res = await this.$api.getArrivedTodaySearch({
                ...searParams
            });
            
            // 初始化商品数据
            if (res.data[0] && res.data[0].goods_list) {
                res.data[0].goods_list.forEach(item => {
                    
                    item.goods_price = this.$handlePrice(item);
                    // 初始化商品数量
                    this.$set(item, "goods_num", 1);
                    // 初始化购物车数量
                    this.$set(item, "cartNum", 0);
                    // 初始化互换件弹窗状态
                    this.$set(item, "replacePopVis", false);
                });
                this.arrivedList = res.data[0].goods_list;
                this.total = Number(res.data[0].total);
            } else {
                this.arrivedList = [];
                this.total = 0;
            }
            
            // 保持品牌列表不变
            // 1
            if (params.type=='screen') {
                this.allTotal = Number(res.data[0].total);
                const brandOrder = ['卢卡斯', 'ATI', 'SCAEG', 'HNW', '崇芳'];
                let orgList = res.oenaturebrandList || [];
                let topBrands = [];
                let otherBrands = [];
                orgList.forEach(item => {
                    let idx = brandOrder.indexOf(item.oenaturebrand);
                    if (idx > -1) {
                        topBrands.push(item);
                    } else {
                        otherBrands.push(item);
                    }
                });
                topBrands.sort((a, b) => brandOrder.indexOf(a.oenaturebrand) - brandOrder.indexOf(b.oenaturebrand));
                this.brandList = [...topBrands, ...otherBrands];
            }else{
                
            }
            
            if(!params.goods_name&&this.selectedGoodsName==''){
                this.goodsNamesList = res.goods_names || [];
            }
        },
        
        toggleBrandExpand() {
            this.brandExpandH = this.brandExpandH == "auto" ? "138px" : "auto";
        },
        
        toggleGoodsNameExpand() {
            this.goodsNameExpandH = this.goodsNameExpandH == "auto" ? "30px" : "auto";
        },
        
        getListByGoodsName(name) {
            if (this.selectedGoodsName === name) {
                this.selectedGoodsName = '';
                this.currentPage = 1;
                this.getArrivedList({});
            } else {
                this.selectedGoodsName = name;
                this.currentPage = 1;
                this.getArrivedList({});
            }
        },
        
        // 按品牌筛选
        getListByBrand(brand) {
            this.selectedGoodsName = '';
            // 如果点击的是当前已选中的品牌，则取消选中
            if (this.selectedBrand === brand) {
                this.selectedBrand = '';
                this.currentPage = 1;
                this.getArrivedList({});
            } else {
                this.selectedBrand = brand;
                this.currentPage = 1;
                this.getArrivedList({});
            }
        },
        
        // 搜索功能
        handleSearch() {
            this.currentPage = 1;
            this.getArrivedList({ search: this.searchText });
        },
        
        // 显示商品详情
        showGoodsInfo(goods) {
            goods.preRou = "今日到货";
            localStorage.setItem("hnw-web-item-data", JSON.stringify(goods));
            this.$router.push("/brand/info");
        },
        
        // 分享商品
        shareGoods(goods) {
            this.$message.info('分享商品');
        },
        
        // 输入数量变化
        impueNumChange(goods) {
            if (isNaN(goods.goods_num)) {
                this.$nextTick(() => {
                    this.$set(goods, "goods_num", 1);
                });
            }
            if (goods.goods_storage > 0 && goods.goods_num > goods.goods_storage) {
                this.$nextTick(() => {
                    goods.goods_num = goods.goods_storage;
                });
                return this.$store.commit("UpDateState", { invDia: true });
            }
        },
        
        // 添加到购物车
        async joinCart(carItem) {
            const tidySubPart = async () => {
                let carMessage = {
                    goods_id: carItem.goods_id,
                    sccode: carItem.sccode,
                    oecode: carItem.oecode,
                    goods_name: carItem.goods_name,
                    goods_price: carItem.goods_price,
                    goods_num: carItem.goods_num,
                    goods_storage: carItem.goods_storage,
                    store_id: carItem.store_id,
                    store_name: carItem.store_name,
                    cart_type: "1"
                };
                
                let res = await this.$api.joinCart([carMessage]);
                //更新记录中 已添加X件 字段
                if(res){
                    carItem.cartNum = Number(carItem.cartNum) + Number(carItem.goods_num);
                }
            };

            if (this.$isCompany()) {
                if (this.$store.state.zero_buy != 1) {
                    if (carItem.goods_storage < 1) {
                        // return this.$store.commit('UpDateState',{invDia:true})
                    } else if (
                        carItem.goods_num + Number(carItem.cartNum) >
                        carItem.goods_storage
                    ) {
                        return this.$store.commit("UpDateState", { invDia: true });
                    }
                }
                // 预购单已添加提示
                if (carItem.goods_storage < 1 && Number(carItem.cartNum) > 0) {
                    tidySubPart();
                } else {
                    tidySubPart();
                }
            }
        },
        
        // 查看互换件
        async showChangeParts(epcPart) {
            try {
                this.arrivedList.forEach(item=>{
                    item.replacePopVis = false
                })
            } catch (error) {
                console.log(error);
            }
            
            if(epcPart.exchange && epcPart.exchange.length>0){
                let oem = epcPart.exchange.join(",")
                this.buyStoreList = []
                
                epcPart.exchange.forEach(oecode=>{
                    let has = this.buyStoreList.some(goods=>goods.oecode==oecode)
                    if(!has){
                        this.buyStoreList.push({
                            oecode
                        })
                    }
                })
                
                epcPart.replacePopVis = true
            }
        },
        async showChangeParts(epcPart) {
            try {
            
                this.arrivedList.forEach(item=>{
                    item.replacePopVis = false
                })
            } catch (error) {
                console.log(error);
                
            }
            if(epcPart.exchange&&epcPart.exchange.length>0){
                let oem =  epcPart.exchange.join(",")
                this.buyStoreList = []
                let res = await this.$api.getBatchSearch({
                oem
                })
                console.log("epcPart",epcPart)
                console.log("res",res)
            
                if(res&&res.length>0){
                let addStr = ''
                res.forEach(goods=>{
                    if(!addStr.includes(goods.oecode)){
                    this.buyStoreList.push({
                        goods_id:goods.goods_id,
                        oecode:goods.oecode
                    })
                    addStr += goods.oecode+","
                    }
                })
                }
                epcPart.exchange.forEach(oecode=>{
                let has = this.buyStoreList.some(goods=>goods.oecode==oecode)
                if(!has){
                    this.buyStoreList.push({
                    oecode
                    })
                }
                
                })
                
                epcPart.replacePopVis = true
            }
            
        },
        toSearch(goods) {
            goods.replacePopVis = false
        },
        
        // 读取历史购买记录
        async readHisList(goods_id) {
            try {
                let res = await this.$api.getGoodsRecord(goods_id);
                this.gooodsHisList = res;
                this.hisVis = true;
            } catch (error) {
                console.error('获取历史购买记录失败:', error);
                this.$message.error('获取历史购买记录失败');
            }
        },
        
        // 显示货位详情
        async openAll(data) {
            // 显示货位
            if(this.$store.state.member_id.includes('1780')){ 
                let allotion = await this.$http(`${this.$axios.defaults.baseURL.replace("web",'public')}index.php?act=search&op=stockInfo`,{skuId:data.skuId})
                this.goodsAllotion = this.$hnwTools.getAllotion(allotion) 
            }
            
            this.openAllotion = true
        },
        
        // 分页处理
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getArrivedList({ 
                oenaturebrand: this.selectedBrand, 
                search: this.searchText 
            });
        },
        
        // 添加到货提醒
        async addArrivalRemind(goods) {
            try {
                let params = {
                    member_name: this.$store.state.member_name,
                    member_id: this.$store.state.member_id,
                    store_id:  this.$store.state.store_id,
                    store_name: this.$store.state.store_name,
                    goods_id: goods.goods_id,
                    arrived_state: this.arrived_state
                };
                let res = await this.$api.insert_goods_arrival(params);
                if (res ) {
                    this.$message.success('添加提醒成功');
                } else {
                    this.$message.error(res && res.msg || '添加提醒失败');
                }
            } catch (error) {
                console.error('添加提醒失败:', error);
                this.$message.error('添加提醒失败');
            }
        },
        
        // 添加催交期
        async addUrge(goods) {
            try {
                let params = {
                    member_name: this.$store.state.member_name,
                    member_id: this.$store.state.member_id,
                    store_id: this.$store.state.store_id,
                    store_name: this.$store.state.store_name,
                    goods_id: goods.goods_id,
                    arrived_state: this.arrived_state
                };
                let res = await this.$api.insert_goods_urge(params);
                if (res ) {
                    this.$message.success('催交期添加成功');
                } else {
                    this.$message.error(res && res.msg || '催交期添加失败');
                }
            } catch (error) {
                console.error('催交期添加失败:', error);
                this.$message.error('催交期添加失败');
            }
        }
    },
    async created(){
        
        await this.getArrivedList({
            type: "screen"
        });

        this.$api.getAnalysisLogNew({
            page: "arrived",
            module: '1',
            click_count: 1
        })
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.arrived-index{
    // padding: 10px;
    padding-top: 5px;
    background: #f5f5f5;
    .arrived-content{
    .tab-header {
            display: flex;
            background: #fff;
            border-bottom: 1px solid #e4e4e4;
            padding: 0 30px;
            .tab-item {
                padding: 12px 0;
                margin-right: 30px;
                cursor: pointer;
                font-size: 16px;
                color: #666;
                border-bottom: 2px solid transparent;
                &.active {
                    color: #3E84D6;
                    border-bottom: 2px solid #3E84D6;
                    font-weight: bold;
                }
            }
            
            .search-container {
                margin-left: auto;
                display: flex;
                align-items: center;
                
              
                // 调整输入框高度
                .el-input__inner {
                    height: 32px;
                    line-height: 32px;
                    border-radius: 0;
                }
                
                .el-button {
                    height: 32px;
                    min-width: 80px;
                    line-height: 32px;
                    padding: 0 5px;
                    box-sizing: border-box;
                }
                .search-box{
                }
            }
        }
        .top-info{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5px;
            padding: 5px 10px;
            background: #fff;
            border-radius: 4px;
            
            .total-count{
                
                font-weight: bold;
                color: #333;
                .value{
                    color: red;
                }
            }
            
            .search-box{
                .el-input{
                    width: 320px;
                }
                
                .el-input__prefix{
                    left: 10px;
                }
                
                .el-input__append{
                    padding-right: 5px;
                }
                
                .el-button{
                    padding: 0 12px;
                    font-size: 14px;
                }
            }
        }
        
        .brand-logo-list{
            margin-bottom: 10px;
            background: #fff;
            padding: 10px ;
            position: relative;
            .el-col{
                height: 140px;
            }
            .img-box{
                position: relative;
                text-align: center;
                margin-bottom: 10px;
                box-shadow: 0px 1px 6px 0px rgba(0,0,0,0.07);
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.3s ease;
                box-sizing: border-box;
                height: 134px;
                // overflow: hidden;
                // height: 30px;
                // margin-bottom: 5px;
                // img{
                //     width: 68px;
                //     position: relative;
                //     top: -10px;
                //     left: -10px;
                // }
                // .image-slot{
                //     line-height: 30px;
                // }
                .el-image{
                    width: 100%;
                    .image-slot{
                        height: 100%;
                        line-height: 134px;
                        text-align: center;
                        font-weight: bold;
                        color: #063376;
                    }
                }
                img{
                    width: 100%;
                    
                    object-fit: contain;
                    
                }
                
                
                .brand-num {
                    position: absolute;
                    background: url(../../assets/newHome/折扣.png);
                    background-size: 40px 20px;
                    width: 40px;
                    height: 20px;
                    right: 0px;
                    top: 3px;
                    text-align: center;
                    line-height: 20px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    font-size: 12px;
                    color: #FFFFFF;
                    z-index: 99;
                    transform: scale(0.8);
                }
                
                &.selected {
                    border: 1px solid #3E84D6;
                    box-shadow: 0 0 10px rgba(62, 132, 214, 0.5);
                }
            }
        }
        
        .brand-list-wrapper {
            overflow: hidden;
            transition: height 0.3s ease;
        }
        
        .brand-logo-list .toggle {
            text-align: center;
            cursor: pointer;
            color: #666;
            font-size: 16px;
            &:hover {
                color: #3E84D6;
            }
           
        }
        
        .goods-names-list {
            margin-bottom: 10px;
            background: #fff;
            padding: 10px;
            display: flex;
            flex-wrap: wrap;
            position: relative;
            border: 1px solid #ddd;
            .names-list-wrapper {
                display: flex;
                flex-wrap: wrap;
                overflow: hidden;
                transition: height 0.3s ease;
                width: 100%;
            }
            .name-item {
                padding: 2px 12px;
                margin: 5px;
                border: 1px solid #ddd;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
                transition: all 0.3s ease;
                &:hover {
                    border-color: #3E84D6;
                    color: #3E84D6;
                }
                &.active {
                    background: #3E84D6;
                    border-color: #3E84D6;
                    color: #fff;
                }
            }
            .toggle {
                text-align: center;
                cursor: pointer;
                color: #666;
                font-size: 16px;
                width: 100%;
                &:hover {
                    color: #3E84D6;
                }
                
            }
        }
        
        .parts-list{
            
            background: #fff;
            // 表头样式
                .product {
                    height: 40px;
                    background: #c4c9cc;
                    .teble-head {
                        display: flex;
                        li {
                            display: flex;
                            height: 40px;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            color: #666;
                            &.oecode {
                                min-width: 250px;
                                max-width: 250px;
                            }
                            &.goods_name {
                                min-width: 180px;
                                max-width: 180px;
                            }
                            &.sccode {
                                min-width: 120px;
                                max-width: 120px;
                            }
                            &.oenaturebrand {
                                min-width: 120px;
                                max-width: 120px;
                            }
                            &.goods_storage {
                                width: 150px;
                            }
                            &.goods_price {
                                width: 82px;
                                position: relative;
                            }
                            .ico {
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                                margin-left: 5px;
                                > i {
                                    cursor: pointer;
                                    font-size: 12px;
                                }
                                i:hover {
                                    transform: scale(1.5);
                                    color: #3E84D6;
                                }
                                .el-icon-caret-top {
                                    position: relative;
                                    top: 3px;
                                }
                                .el-icon-caret-bottom {
                                    position: relative;
                                    top: -3px;
                                }
                                .active {
                                    color: #3E84D6;
                                }
                            }
                            &.specification {
                                width: 90px;
                            }
                            &.numAd {
                                width: 114px;
                            }
                            &.handle-box {
                                width: 86px;
                            }
                        }
                    }
                }
            // 旧配件列表样式
                .cargo {
                    display: flex;
                    box-sizing: border-box;
                    position: relative;
                    box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.13);
                    margin-bottom: 20px;
                    > ul {
                        width: 100%;
                    }
                    .case-list {
                        &.isAll {
                            height: auto;
                        }
                    }
                    .case-list:nth-child(2n) {
                        background: #f7f7f7;
                    }
                    
                    .details {
                        display: flex;
                        position: relative;
                        .watermark-text{
                            position: absolute;
                            left: 20%;
                            top: 20%;
                        }
                        >div{
                            box-sizing: border-box;
                        }
                        .isOe {
                            position: relative;
                            width: 250px;
                            border-right: 1px solid #e3e4ea;
                            display: flex;
                            justify-content: space-between;
                            
                            .isOe-left {
                                width: 98%;
                                .isOe-top {
                                    display: flex;
                                    margin-top: 14px;
                                    margin-bottom: 10px;
                                    margin-left: 10px;
                                    position: relative;
                                    .hnw-copy{
                                        position: absolute;
                                        right: 36px;
                                        top: -6px;
                                    }
                                    .name {
                                        width: 48px;
                                        height: 20px;
                                        background-color: #3E84D6;
                                        font-size: 12px;
                                        text-align: center;
                                        line-height: 20px;
                                        color: #fff;
                                    }
                                    .number {
                                        cursor: pointer;
                                        max-width: 100px;
                                        margin-left: 5px;
                                        margin-top: 2px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                        padding-top: 0;
                                        color: #333;
                                    }
                                    .tag-icon {
                                        display: flex;
                                        align-items: center;
                                        transform: scale(0.7);
                                        justify-content: center;
                                        width: 20px;
                                        height: 20px;
                                        background: #3E84D6;
                                        color: #fff;
                                        border-radius: 50%;
                                        font-size: 12px;
                                        position: relative;
                                        top: -8px;
                                        left: 2px;
                                    }
                                }
                                .vehicleModel {
                                    margin: 0 0 0 10px;
                                    max-width: 230px;
                                    box-sizing: border-box;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    cursor: pointer;
                                    font-size: 14px;
                                    color: #999;
                                }
                            }
                        }
    
                        .productName {
                            width: 180px;
                            line-height: 69px;
                            border-right: 1px solid #e3e4ea;
                            overflow: hidden;
                            text-align: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            position: relative;
                            .product-top{
                                position: absolute;
                                right: 0px;
                                top: 0px;
                                display: flex;
                                align-items: center;
                                padding-right: 5px;
                                >div{
                                    cursor: pointer;
                                }
                                .dis-good-tips-small {
                                    background: url(../../assets/newHome/折扣.png);
                                    background-size: 40px 20px;
                                    width: 40px;
                                    height: 20px;
                                    margin-left: 6px;
                                    text-align: center;
                                    line-height: 20px;
                                    font-family: Source Han Sans CN;
                                    font-weight: 500;
                                    font-size: 12px;
                                    color: #FFFFFF;
                                    z-index: 99;
                                }
                                .cx-icon{
                                    width: 22px;
                                    margin-left: 8px;
                                }
                            }
                            .share-btn{
                                line-height: 1;
                                margin-left: 6px;
                                
                                img{
                                    width: 20px;
                                }
                            }
                            .del-time{
                                position: absolute;
                                left: 20px;
                                bottom: -20px;
                                
                            }
                        }
    
                        .encoding {
                            overflow: hidden;
                            width: 120px;
                            line-height: 69px;
                            border-right: 1px solid #e3e4ea;
                            text-align: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            position: relative;
                            .hnw-copy{
                                position: absolute;
                                right: 20px;
                                top: 8px;
                            }
                        }
                        
                        .brand {
                            overflow: hidden;
                            width: 120px;
                            line-height: 69px;
                            border-right: 1px solid #e3e4ea;
                            text-align: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            position: relative;
                            .hnw-self-brand {
                                position: absolute;
                                bottom: -25px;
                                left: 50%;
                                transform: translateX(-50%);
                                color: #ff7519;
                            }
                        }
                        
                        // 自选品牌
                        .selfBrand {
                            background: #d9ecff;
                            border-bottom: 1px solid #ccc;
                        }
                        
                        .inventory {
                            width: 150px;
                            box-sizing: border-box;
                            border-right: 1px solid #e3e4ea;
                            text-align: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            padding: 5px 0;
                            .goods-location{
                                >div{
                                    color: #2473FF;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    margin-right: 3px;
                                }
                            }
                            .loca-btn{
                                cursor: pointer;
                                padding: 1px;
                                color: #fff;
                                background: #FFAB00;
                                width: 66px;
                                text-align: center;
                                margin: 2px auto 0;
                            }
                            .goods-cangTip{
                                color: #F94F4C;
                                font-size: 12px;
                                margin-left: 5px;
                                font-weight: bold;
                            }
                        }
                        
                        .arrival-btn-box {
                            padding-top: 2px;
                            width: 100%;
                            box-sizing: border-box;
                            // border-right: 1px solid #e3e4ea;
                            display: flex;
                          
                            justify-content: center;
                            align-items: center;
                            // padding: 5px;
                            // gap: 5px;
                            .el-button {
                                padding: 4px 8px;
                                font-size: 12px;
                            }
                        }
                        
                        .TheOrderPrice {
                            position: relative;
                            width: 82px;
                            border-right: 1px solid #e3e4ea;
                            line-height: 69px;
                            text-align: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            .watermark-text{
                                right: 0px !important;
                                top: -4px;
                            }
                            span {
                                position: relative;
                                top: 1px;
                            }
                        }
    
                        .specification {
                            overflow: hidden;
                            width: 90px;
                            border-right: 1px solid #e3e4ea;
                            line-height: 69px;
                            text-align: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
    
                        .numAd {
                            width: 114px;
                            border-right: 1px solid #e3e4ea;
                            line-height: 69px;
                            position: relative;
                            text-align: center;
                            .el-input-number {
                                // margin: 0 0px 0 10px;
                                width: 100px;
                            }
                            .goods-Fcl-tit {
                                position: absolute;
                                left: 50%;
                                transform: translateX(-50%);
                                bottom: 2px;
                                font-size: 12px;
                                line-height: 12px;
                                width: 120px;
                                text-align: center;
                                color: #999;
                            }
                            .red {
                                color: red;
                            }
                        }
    
                        .handle-box {
                            position: relative;
                            box-sizing: border-box;
                            padding: 5px 0;
                            width: 86px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            .addition {
                                font-size: 14px;
                                color: #999;
                            }
                            .replace-btn {
                                color: #3E84D6;
                                cursor: pointer;
                            }
                            .add-btn {
                                width: 80px;
                                height: 22px;
                                padding: 0;
                                color: #59a8f8;
                                font-size: 14px;
                                font-weight: 400;
                                line-height: 20px;
                                border-radius: 0px;
                                text-align: center;
                                cursor: pointer;
                            }
                            .add-btn:active{
                                transform: scale(1.1);
                            }
                            .ycg-btn {
                                background: #f5f5f5;
                                color: #999;
                                border: 1px solid #dcdfe6;
                            }
                        }
                    }
                    
                    .goods-ex-msg {
                        display: flex;
                        border-top: 1px solid #e3e4ea;
                        justify-content: flex-end;
                        align-items: center;
                        line-height: 30px;
                        height: 30px;
                        .buyHis {
                            cursor: pointer;
                            text-align: right;
                            padding: 0 5px;
                            color: red;
                            font-size: 12px;
                            > span {
                                margin-right: 10px;
                                align-items: center;
                            }
                            .readMore {
                                cursor: pointer;
                            }
                        }
                    }
                }
            
            .pages{
                text-align: right;
                margin-top: 20px;
            }
        }
        
        // 货位详情样式
        .alltion {
            display: flex;
            margin-bottom: 10px;
            div {
                flex: 1;
                text-align: center;
                padding: 5px 0;
                &.item {
                    border-bottom: 1px solid #f0f0f0;
                }
            }
        }
        
        // 历史购买记录样式
        .his-list {
            .list-head {
                display: flex;
                background: #f5f5f5;
                padding: 10px 0;
                div {
                    flex: 1;
                    text-align: center;
                    font-weight: bold;
                    &.col-100 {
                        width: 100px;
                    }
                }
            }
            .list-body {
                .row {
                    display: flex;
                    padding: 10px 0;
                    border-bottom: 1px solid #f0f0f0;
                    div {
                        flex: 1;
                        text-align: center;
                        &.col-100 {
                            width: 100px;
                        }
                    }
                }
            }
        }
    }
}
</style>